"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var import_courses_html_1 = __importDefault(require("./import-courses.html"));
var import_courses_controller_1 = __importDefault(require("./import-courses.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.settings.importcourses", {
        url: "/import-courses",
        controller: import_courses_controller_1.default,
        controllerAs: "vm",
        template: import_courses_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.settings.importcourses", [])
    .config(config)
    .controller("AdminImportCoursesController", import_courses_controller_1.default);
